module.exports = __webpack_public_path__ + "static/media/beach-marker.cfafeca2.png";